import axios from 'axios';

export const getPublicAxios = () =>
  axios.create({
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
